import React from "react";
import cx from "classnames";
import { Link, navigate } from "gatsby";

import { IconArrow } from "assets/media/svgs";

import * as styles from "./SideNav.module.scss";
import { Category, Guide } from "types";

interface SideNavProps {
  title: string;
  categories?: Category[];
  guides?: Guide[];
  type: "Index" | "Category";
  pathPath: string;
}

const SideNav: React.FC<SideNavProps> = ({
  type,
  title,
  categories,
  guides,
  pathPath,
}) => {
  return (
    <div className={styles.SideNav_container} role="secondary navigation">
      <div>
        <h3
          className={styles.SideNav_title}
          onClick={() => type === "Category" && navigate("/guides")}
        >
          {type === "Category" && <IconArrow />} {title}
        </h3>
        <ul
          className={cx(styles.SideNav_list, {
            [styles.SideNav_list_category]: type === "Category",
          })}
        >
          {(categories || guides)?.map(({ attributes }) => {
            let label = "";
            if (attributes.hasOwnProperty("name")) {
              label = attributes["name"];
            }
            if (attributes.hasOwnProperty("title")) {
              label = attributes["title"];
            }
            return (
              <li key={attributes.slug} className={styles.SideNav_list_item}>
                <Link
                  to={`${pathPath}/${attributes.slug}`}
                  className={styles.SideNav_list_item_link}
                  activeClassName={styles.SideNav_list_item_link_active}
                >
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideNav;
